<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.bulk_log">
  <div class="banner center" style="max-width:800px;" *ngIf="source">
    <div class="row_header freeze_height">
      <div class="row">
        <div class="col-6">
          <ngx-select [(ngModel)]="selectedLogStatus" [noAutoComplete]="true" [items]="source.statusSummary"
            [optionValueField]="'key'" [optionTextField]="'value'" (select)="onStatusSelect()">
            <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
              <span>{{onGetText(2,option.data.key)}}</span>
              <span class="en">&nbsp;({{option.data.value}})&nbsp;</span>
            </ng-template>
          </ngx-select>
        </div>
        <div class="col-6">
          <button class="button_icon button_icon_color icon_adjust" [disabled]="iCurrentRow == 1"
            (click)="onGetLogDetail(1)">arrow_circle_left</button>
          <span class="en">&nbsp;{{iCurrentRow}}/{{iTotalCount}}&nbsp;</span>
          <button class="button_icon button_icon_color icon_adjust" [disabled]="iCurrentRow == iTotalCount"
            (click)="onGetLogDetail(2)">arrow_circle_right</button>
        </div>
      </div>
    </div>
    <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row">
        <div class="col-md-6">
          <div class="row styled_row">
            <div class="col-4">
              <span class="label_left">{{localService.languageContent.bulk_log.status}}</span>
            </div>
            <div class="col-8">
              <span>{{onGetText(2,source.details.LogStatus)}}</span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row styled_row">
            <div class="col-4">
              <span class="label_left">{{localService.languageContent.bulk_log.reason}}</span>
            </div>
            <div class="col-8">
              <span>{{onGetText(3,source.details.LogReason)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label>{{localService.languageContent.bulk_log.input_data}}</label>
        </div>
      </div>
      <div class="row styled_row" *ngFor="let item of source.details.LogData">
        <div class="col-6">
          <span class="label_left">{{onGetText(1,item.key)}}</span>
        </div>
        <div class="col-6">
          <span>{{item.value}}</span>
        </div>
      </div>
    </div>
  </div>
</div>